import { Tap } from '@iotize/tap';

import {
  EncryptionKeys,
  ScramInterceptor,
  EncryptionOptions,
} from './scram-interceptor';

export interface EncryptionSessionState {
  enabled?: boolean;
  keys?: EncryptionKeys;
  frameCounter?: number;
}

export class TapEncryption {
  private scramInterceptor: ScramInterceptor;

  get isStarted() {
    return this.scramInterceptor.options.encryption;
  }

  // private _sessionState: BehaviorSubject<EncryptionKeys>;

  constructor(private tap: Tap) {
    this.scramInterceptor = new ScramInterceptor(this.tap.service.scram);
    this.tap.client.addInterceptor(this.scramInterceptor);
    // this._sessionState = new BehaviorSubject<EncryptionKeys>(this._scramInterceptor.options.keys);
    this.tap.events.subscribe((event) => {
      switch (event.type) {
        // Stop encryption on tap logout
        case 'tap-logout':
          this.stop();
          break;
      }
    });
  }

  setEncryptionKeys(keys: EncryptionKeys) {
    this.scramInterceptor.setEncryptionKeys(keys);
  }

  setEncryptedFrameCounter(frameCounter: number) {
    this.scramInterceptor.setFrameCounter(frameCounter);
  }

  public getEncryptionOptions(): EncryptionOptions {
    return this.scramInterceptor.options;
  }

  public refreshEncryptionInitializationVector() {
    return this.scramInterceptor.refreshInitializationVectors();
  }

  public setInitializationVectorRefreshPeriod(period: number) {
    return this.scramInterceptor.setInitializationVectorRefreshPeriod(period);
  }

  // /**
  //  * Enable/Disable encrytion when communicating with a device
  //  * @param enable true if requests must be encrypted
  //  * @param resetSessionKey true if you want to reset the the session key.
  //  * @param refreshInitializationVector true if you want to change initialization vectors
  //  *
  //  * @deprecated use {@link encryption()} instead
  //  */
  // public async enableEncryption(
  //     enable: boolean,
  //     resetSessionKey = false,
  //     refreshInitializationVector = false
  // ): Promise<void> {
  //     return this.encryption(
  //         enable,
  //         resetSessionKey,
  //         refreshInitializationVector
  //     );
  // }

  // /**
  //  * Enable/Disable encrytion when communicating with a device
  //  * @param enable true if requests must be encrypted
  //  * @param resetSessionKey true if you want to reset the the session key.
  //  * @param refreshInitializationVector true if you want to change initialization vectors
  //  *
  //  */
  // public async encryption(
  //     enable: boolean,
  //     resetSessionKey = false,
  //     refreshInitializationVector = false
  // ): Promise<void> {
  //     await this.scramInterceptor.encryption(
  //         enable,
  //         resetSessionKey,
  //         refreshInitializationVector
  //     );
  // }

  /**
   * Enable encryption
   */
  public async start() {
    const keys = await this.scramInterceptor.newSession();
    this.scramInterceptor.resumeEncryption();
    return keys;
  }

  /**
   * Disable encryption
   */
  public stop() {
    this.scramInterceptor.clearSession();
  }

  /**
   * Pause encryption
   */
  public pause() {
    this.scramInterceptor.pauseEncryption();
  }

  /**
   * Pause encryption
   */
  public resume() {
    this.scramInterceptor.resumeEncryption();
  }

  /**
   * Setter for the session key
   * @param key if null, it will stop encryption and remove session key. If true it will update session key used for encryption
   */
  public set sessionKey(key: Uint8Array | undefined) {
    this.scramInterceptor.sessionKey = key;
  }

  /**
   * Get current session key for encrypted communicatioin
   */
  public get sessionKey(): Uint8Array | undefined {
    return this.scramInterceptor.sessionKey;
  }
}
